import {createAction, handleActions} from 'redux-actions';

const SET_CODE = 'code/SET_CODE';
export const setCode = createAction(SET_CODE);

// 초기 state를 정해줍니다
let initialState = {
	param: {
		// 'current_page': 1,
		// 'record_per_page': 20,
		'disp_yn': 'Y',
		'del_yn' : 'N',
		// 	'ks': '',
		// 	'sub_ks': '',
		// 	'jcr_category': [],
		// 	'kci_category': [],
		// 	'scopus_category': [],
		// 	'publisher': [],
		// 	'registered_db_name': [],
		// 	'registered_db_year': [],
		// 	'code_ranking': [],
		// 	'dept': [],
		// 	'order_by': 'date',
		// 	'order': 'dec',
	},
	parentRecords: [],
	childRecords: [],
	selectChildCodeId : '',
	// facet: {},
	// totalRecords: 0,
	// totalPage: 0,
	// record: {},
	// meta: {},
	// similar: [],
	// fullText: [],
	// isPopup1: 'false',
	// type: ''
}

export default handleActions({
	[SET_CODE]: (state, action) => {
		action.payload = action.payload ? action.payload : {}

		return {
			...state,
			param: {
				...state.param,
				disp_yn: action.payload.param && action.payload.param.disp_yn ? action.payload.param.disp_yn : state.param.disp_yn,
				del_yn: action.payload.param && action.payload.param.del_yn ? action.payload.param.del_yn : state.param.del_yn,
			},
			parentRecords: action.payload.parentRecords ? action.payload.parentRecords : state.parentRecords,
			// childRecords: action.payload.childRecords ? action.payload.childRecords : state.childRecords,
			childRecords: action.payload.childRecords ? action.payload.childRecords : state.childRecords,
			//
			selectChildCodeId: action.payload.selectChildCodeId ? action.payload.selectChildCodeId : state.selectChildCodeId,
			// record: action.payload.record ? action.payload.record : state.record,
			// facet: action.payload.facet ? action.payload.facet : state.facet,
			// totalRecords: action.payload.pageInfo ? action.payload.pageInfo.totalReults : state.totalRecords,
			// totalPage: action.payload.pageInfo ? action.payload.pageInfo.totalPage : state.totalPage,
			// isPopup1: action.payload.isPopup1 === 'true' ? 'true' : 'false',
			// type: action.payload.type ? action.payload.type : state.type
		}
	},
	// [SET_CODE]: (state, action) => {
	// 	return {
	// 		...state,
	// 		// record: action.payload.record ? action.payload.record : state.record,
	// 		// meta: action.payload.meta ? action.payload.meta : state.meta,
	// 		// similar: action.payload.similar ? action.payload.similar : state.similar,
	// 		// fullText: action.payload.fullText ? action.payload.fullText : state.fullText,
	// 	}
	// },
}, initialState)
